import { format, parse, subDays } from "date-fns";
import { property } from "lodash";
import { all, call, put } from "redux-saga/effects";

import { ReportType } from "constants/reports/report-type";
import { serializeFilters } from "services/api/report/report-serializer";
import { IActionWithPayload } from "store/helper";
import { isReportTypeIsDisabled } from "store/views/reports/helpers";

import { ReportActions } from "../actions";
import { IFetchReportPayload } from "../interfaces";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getCombinations(elements: any[]): any[] {
  const results = [[]];
  elements.forEach(value => {
    const copy = [...results];
    copy.forEach(prefix => {
      results.push(prefix.concat(value));
    });
  });
  return results.filter(el => el.length);
}

export function* makeFetchingSaga(
  reportType: ReportType,
  action: IActionWithPayload<string, IFetchReportPayload>,
  requests = [],
  extendedFilters = {}
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): any {
  const { payload } = action;
  const { filters, distribution } = payload;

  const serializedFilters = {
    // @ts-expect-error TS(2345): Argument of type 'ReportDistribution | undefined' ... Remove this comment to see the full error message
    ...serializeFilters(filters, distribution, []),
    ...extendedFilters,
  };

  const isComparisonDisabled = isReportTypeIsDisabled(reportType);
  const comparisons = !isComparisonDisabled
    ? // @ts-expect-error TS(2769): No overload matches this call.
      Object.keys(filters).filter(filter => property("compare")(filters[filter]))
    : [];

  const filtersSets = getCombinations(comparisons).reduce(
    (acc, comparison) => {
      acc.push({
        // @ts-expect-error TS(2345): Argument of type 'ReportDistribution | undefined' ... Remove this comment to see the full error message
        ...serializeFilters(filters, distribution, comparison),
        ...extendedFilters,
      });
      return acc;
    },
    [serializedFilters]
  );

  let dataSets = requests.reduce((acc, request) => {
    // @ts-expect-error TS(2339): Property 'disableComparison' does not exist on typ... Remove this comment to see the full error message
    if (request.disableComparison || isComparisonDisabled) {
      return acc.concat([
        // @ts-expect-error TS(2571): No overload matches this call.
        {
          filters: filtersSets[0],
          filterSetId: 0,
          request,
          data: null,
        },
      ]);
    }
    return acc.concat(
      // @ts-expect-error TS(7006): Parameter 'filtersSet' implicitly has an 'any' typ... Remove this comment to see the full error message
      ...filtersSets.map((filtersSet, index) => ({
        filters: filtersSet,
        filterSetId: index,
        request,
        data: null,
      }))
    );
  }, []);

  // @ts-expect-error TS(2339): Property 'request' does not exist on type 'never'.
  const responses = yield all(dataSets.map(set => call(set.request.interface, set.filters)));

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  if (responses.every((response: any) => response.result)) {
    // @ts-expect-error TS(7006): Parameter 'filtersSet' implicitly has an 'any' typ... Remove this comment to see the full error message
    dataSets = filtersSets.map((filtersSet, index) => ({
      filters: filtersSet,

      data: requests.reduce((acc, request, requestId) => {
        if (responses[requestId * filtersSets.length + index]) {
          // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
          acc[request.name] = responses[requestId * filtersSets.length + index].result;
        }
        return acc;
      }, {}),
    }));

    yield put(
      ReportActions.fetchSuccess({
        data: dataSets,
        source: payload.source,
        reportType,
      })
    );
  } else {
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const errors = responses.map((request: any) => request.error && request.error.error);

    yield put(ReportActions.fetchFailure({ errors, reportType }));
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const prepareRequestsForLast7Days = (filters: any): any[] => {
  // TODO: take distribution from parameter after API change
  const now = new Date();

  const requests = new Array(7)
    .fill(null)
    // @ts-expect-error TS(6133): 'element' is declared but its value is never read.
    .map((element, index) => {
      const date = format(subDays(now, index), "YYYY-MM-DD");
      return { ...filters, dateFrom: date, dateTo: date, distribution: "hour" };
    })
    .reverse();

  return requests;
};

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
export function parseHeatmapResponse(response: any) {
  const result = {};
  Object.keys(response).forEach(date => {
    const parsedDate = parse(date);
    const dateKey = format(parsedDate, "YYYY-MM-DD");
    const hour = format(parsedDate, "H");
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    if (!result[dateKey]) {
      // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      result[dateKey] = {};
    }
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    result[dateKey][hour] = response[date];
  });
  // @ts-expect-error TS(2769): No overload matches this call.
  return Object.keys(result).reduce((acc, date) => {
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    const data = result[date];
    return [
      ...acc,
      {
        data,
        date,
      },
    ];
  }, []);
}
